import { buildTree } from './buildTree';
import {
  BuildChecklistTreeFromSourcesInput,
  ChecklistItemSource,
  ChecklistItemTreeData,
  ChecklistSectionSource,
  ChecklistSectionTreeData,
  TreeNode,
} from './types';

export function toChecklistSectionTreeData(
  section: ChecklistSectionSource
): ChecklistSectionTreeData {
  return {
    _id: section._id,
    title: section.title,
    description: section.description,
    order: section.order,
    parentSectionId: section.parentSectionId,
    deleted: section.deleted,
  };
}

export function toChecklistItemTreeData(
  item: ChecklistItemSource
): ChecklistItemTreeData {
  return {
    _id: item._id,
    summary: item.summary,
    norm: {
      description: item.norm?.description || '',
    },
    index: item.index,
    order: item.order,
    parentSectionId: item.parentSectionId,
    answers: item.answers,
    deleted: item.deleted,
  };
}

export function buildChecklistTreeFromSources({
  sections,
  items,
  excludeDeleted,
}: BuildChecklistTreeFromSourcesInput): TreeNode[] {
  const filteredSections = excludeDeleted
    ? sections.filter((section) => !section.deleted)
    : sections;
  const filteredItems = excludeDeleted
    ? items.filter((item) => !item.deleted)
    : items;

  return buildTree(
    filteredSections.map(toChecklistSectionTreeData),
    filteredItems.map(toChecklistItemTreeData)
  );
}
